<template>
  <v-dialog :value="open" width="500" persistent>
    <v-card>
      <v-card-title>{{ $t('app.loginStartedHeadline') }}</v-card-title>
      <v-card-text> {{ $t('app.loginStartedText') }} </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="btn" rounded :elevation="0" color="primary" @click="startLogin">{{
          $t('app.login')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LoginDialog',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    startLogin() {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(registration => {
          console.log('registration.active:', registration.active)
          window.startSSOLoginFlow()
        })
      } else {
        console.error('Service workers are not supported.')
      }
    },
  },
}
</script>

<style></style>
